<goab-details [heading]="title ?? defaultTitle" maxWidth="100%" [mt]="marginTop">
  <div class="details-content">
    <ng-content></ng-content>
  </div>
</goab-details>
